import { http, HttpResponse } from "msw";
import { apiKeys } from "../data/apiKeys";
import { BackendId } from "@libs/appliance_common";
const mockUserId = "11111111-1111-1111-1111-111111111111";
export const apiKeysQueryHandlers = [
    http.get("/api/admin/api-keys", ()=>{
        const res = {
            api_keys: apiKeys
        };
        return HttpResponse.json(res);
    })
];
export const apiKeysMutationHandlers = [
    http.post("/api/admin/api-keys", async ({ request })=>{
        const body = await request.json();
        const newApiKey = {
            id: crypto.randomUUID(),
            name: body.name,
            user_id: mockUserId,
            user_backend: BackendId.Local,
            created_at: new Date().toISOString(),
            expires_at: new Date(Number(body.expires_in) * 1000).toISOString(),
            username: "mockuser",
            scopes: body.scopes
        };
        apiKeys.push(newApiKey);
        const res = {
            name: newApiKey.name,
            // TODO: mocks are mixed up for expiration date. Fix.
            expires_at: body.expires_in,
            api_key: "mock-api-key-" + crypto.randomUUID()
        };
        return HttpResponse.json(res);
    }),
    http.delete("/api/admin/api-keys/:id", ({ params })=>{
        const index = apiKeys.findIndex((key)=>key.id === params.id);
        if (index !== -1) {
            apiKeys.splice(index, 1);
        }
        const res = {
            success: true,
            message: "API key revoked successfully",
            error_code: null
        };
        return HttpResponse.json(res);
    })
];
const apiKeysHandlers = [
    ...apiKeysQueryHandlers,
    ...apiKeysMutationHandlers
];
export default apiKeysHandlers;
